import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { TipoEspacioProvider } from './Components/context/FiltroTipoEspacioContext';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <TipoEspacioProvider>
                <App />
            </TipoEspacioProvider>

        </BrowserRouter>
    </React.StrictMode>
);

reportWebVitals();
